import { GemsApi_StonePolish } from '@/graphql/api'
import { computed, type ComputedRef, type Ref, toValue } from 'vue'
import { findOrder } from '@/domain/stone/search/findOrder'

const ordered: GemsApi_StonePolish[] = [
    GemsApi_StonePolish.Ideal,
    GemsApi_StonePolish.Excellent,
    GemsApi_StonePolish.VeryGood,
    GemsApi_StonePolish.Good,
    GemsApi_StonePolish.Fair,
] as const

function findPolishOrder(code: GemsApi_StonePolish) {
    return findOrder(ordered, code)
}

export function useOrderedPolish(
    shapes: Ref<GemsApi_StonePolish[]> | (() => GemsApi_StonePolish[])
): ComputedRef<GemsApi_StonePolish[]> {
    return computed(() => {
        return toValue(shapes).sort(
            (a: GemsApi_StonePolish, b: GemsApi_StonePolish) => {
                const orderA = findPolishOrder(a)
                const orderB = findPolishOrder(b)

                return orderA - orderB
            }
        )
    })
}
